<template>
  <v-app light>
    <v-navigation-drawer v-if="isMobile" v-model="drawer" fixed app>
      <v-list dense>
        <!-- <v-list-tile @click="" :to="{path: 'home'}">
          <v-list-tile-content>
            <v-list-tile-title><span class="menu-title">Home</span></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="" :to="{path: 'listing'}">
          <v-list-tile-content>
            <v-list-tile-title><span class="menu-title">Listings</span></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <v-list-item link :to="{ path: 'home' }">
          <v-list-item-content>
            <v-list-item-title
              ><span class="menu-title">Home</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: 'listing' }">
          <v-list-item-content>
            <v-list-item-title
              ><span class="menu-title">Listings</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: 'testimonial' }">
          <v-list-item-content>
            <v-list-item-title
              ><span class="menu-title">Testimonials</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: 'homevalue' }">
          <v-list-item-content>
            <v-list-item-title
              ><span class="menu-title">Home Value</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: 'contact' }">
          <v-list-item-content>
            <v-list-item-title
              ><span class="menu-title">Contact</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ path: 'about' }">
          <v-list-item-content>
            <v-list-item-title
              ><span class="menu-title">About</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="switchLang">
          <v-list-item-content>
            <v-list-item-title>中文</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- v-toolbar color="grey lighten-4" fixed app-->
    <v-app-bar color="grey lighten-4" fixed app>
      <v-app-bar-nav-icon
        v-if="isMobile && !drawer"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <!--<v-toolbar-title>Application</v-toolbar-title>-->
      <img
        v-if="!isMobile"
        :src="require('@/assets/img/remax_balloon.png')"
        style="max-height: 45px"
      />
      <v-spacer></v-spacer>
      <img
        v-if="isMobile"
        :src="require('@/assets/img/remax_balloon.png')"
        class="mobile remax-balloon"
      />
      <div class="hidden-sm-and-down">
        <v-btn :to="{ path: 'home' }" text
          ><span class="grey--text--darken-2 menu-title">Home</span></v-btn
        >
        <v-btn :to="{ path: 'listing' }" text
          ><span class="grey--text--darken-2 menu-title">Listings</span></v-btn
        >
        <v-btn :to="{ path: 'testimonial' }" text
          ><span class="grey--text--darken-2 menu-title"
            >Testimonials</span
          ></v-btn
        >

        <v-btn :to="{ path: 'homevalue' }" text
          ><span class="grey--text--darken-2 menu-title"
            >Home Value</span
          ></v-btn
        >
        <v-btn text :to="{ path: 'contact' }"
          ><span class="grey--text--darken-2 menu-title">Contact</span></v-btn
        >
        <v-btn :to="{ path: 'about' }" text
          ><span class="grey--text--darken-2 menu-title">About</span></v-btn
        >
        <v-btn @click="switchLang" text
          ><span class="grey--text--darken-2">中文</span></v-btn
        >
      </div>
    </v-app-bar>

    <div>
      <v-content>
        <router-view></router-view>
      </v-content>
    </div>
    <home-footer></home-footer>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import HomeFooter from "../components/Footer";
import About from "./About";
import Listing from "./Listing";
import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);

export default {
  name: "Home",
  components: {
    HomeFooter,
    About,
    Listing,
  },
  data() {
    return {
      isDesktop: false,
      title: "",
      drawer: false,
      navbarHidden: false,
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.homeStore.isMobile,
      isZh: (state) => state.homeStore.isZh,
    }),
  },
  mounted() {
    this.switchDevice();
    window.addEventListener("resize", this.switchDevice, { passive: true });
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.switchDevice);
    }
  },
  methods: {
    ...mapMutations([
      "setMobile",
      "setSmallDisplay",
      "setViewWidth",
      "setViewHeight",
    ]),
    switchDevice() {
      this.setMobile(window.innerWidth <= 960);
      this.setSmallDisplay(window.innerWidth < 600 || window.innerHeight < 600);
      this.setViewWidth(window.innerWidth);
      this.setViewHeight(window.innerHeight);
      this.isDesktop = !this.isMobile;
      // this.hideNavbar();
      // this.resizeIframe();
    },
    switchLang() {
      this.$router.push("zh" + this.$route.path);
    },
    // hideNavbar and resizeIframe methods that perform direct DOM manipulation should be refactored
    // to use Vue's data-driven approach, possibly with component props or a shared state.
    // Since the related components are not in context, I've removed them for now.
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "home.css";
</style>
